import { render, staticRenderFns } from "./TicketShops.vue?vue&type=template&id=acfc4940"
import script from "./TicketShops.vue?vue&type=script&lang=js"
export * from "./TicketShops.vue?vue&type=script&lang=js"
import style0 from "./TicketShops.vue?vue&type=style&index=0&id=acfc4940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports